import { Answer } from './answer'
import { Attachment } from './attachment'
import { ReviewResultEnum } from './review-result-enum'

export interface CreateReviewInterface {
  answer?: Answer
  /**
   * 所在学案id
   */
  handoutId?: number
  /**
   * 所在大纲id
   */
  outlineId?: number
  questionId?: number
  answerId?: number
  /**
   * 答案版本VID
   */
  answerVid?: number
  /**
   * 批改人id
   */
  reviewerId?: number
  /**
   * 答题人id
   */
  submitterId?: number
  /**
   * 批改结果
   */
  result?: ReviewResultEnum | null
  /**
   * 得分
   */
  gainedScore?: string | null
  /**
   * 评语内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: Attachment[]
  /**
   * 是否发布
   */
  isPublished?: boolean
}

export class CreateReview implements CreateReviewInterface {
  answer?: Answer
  /**
   * 所在学案id
   */
  handoutId?: number
  /**
   * 所在大纲id
   */
  outlineId?: number
  questionId?: number
  answerId?: number
  /**
   * 答案版本VID
   */
  answerVid?: number
  /**
   * 批改人id
   */
  reviewerId?: number
  /**
   * 答题人id
   */
  submitterId?: number
  /**
   * 批改结果
   */
  result?: ReviewResultEnum | null
  /**
   * 得分
   */
  gainedScore?: string | null
  /**
   * 评语内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: Attachment[]
  /**
   * 是否发布
   */
  isPublished?: boolean

  constructor(props: CreateReviewInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      answer: _answer,
      handoutId: _handoutId,
      outlineId: _outlineId,
      questionId: _questionId,
      answerId: _answerId,
      answerVid: _answerVid,
      reviewerId: _reviewerId,
      submitterId: _submitterId,
      result: _result,
      gainedScore: _gainedScore,
      content: _content,
      attachments: _attachments,
      isPublished: _isPublished,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.answer = _answer ? new Answer(_answer) : _answer
    this.handoutId = _handoutId
    this.outlineId = _outlineId
    this.questionId = _questionId
    this.answerId = _answerId
    this.answerVid = _answerVid
    this.reviewerId = _reviewerId
    this.submitterId = _submitterId
    this.result = _result
    this.gainedScore = _gainedScore
    this.content = _content
    this.attachments = _attachments
      ? _attachments.map((i) => new Attachment(i))
      : _attachments
    this.isPublished = _isPublished
  }
}
